import axios from 'axios';
import { config } from '../apiConfig';

const RequestOrganizationCode = async (parameters) => {
    let AccessToken = localStorage.getItem('AccessToken');
    if (AccessToken) {
        let response = await axios.post(`${config.url}/api/mvc/OrganizationMember/RequestOrganizationCode`, parameters,
         {
        headers: { "Authorization": `Bearer ${AccessToken}` }
    }).catch((err) => {
        return err.response;
    });
    return response;
}else{
        window.location.href = 'https://iranhotelonline.com';

}
}

export default RequestOrganizationCode;